<template>
  <JazelAppContainer
    app-name="Model Research Pages"
    @update:account-settings="accountSettings.setAccountSettings($event)"
    @update:session-token="accountSettings.setSessionToken($event)"
    @update:is-client-user="accountSettings.setIsClientUser($event)"
    @update:product-settings="productSettings.setProductSettings($event)"
  >
    <Dashboard />
  </JazelAppContainer>
</template>

<script setup lang="ts">
import Dashboard from './pages/Dashboard.vue'
import { useAccountSettingsStore } from './stores/accountSettings'
import { useProductSettingsStore } from '@/stores/productSettings'
import {JazelAppContainer} from "@jazel/jazel-vuetify";

const accountSettings = useAccountSettingsStore()
const productSettings = useProductSettingsStore()
</script>

<style scoped>
#lightning-model-page-admin :deep(.v-text-field .v-field--no-label input),
#lightning-model-page-admin :deep(.v-text-field .v-field--active input) {
  padding: 12px 16px;
  border-style: none;
  box-shadow: none;
  min-width: 56px;
}
</style>
